<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <span>
    <b-dropdown
      left
      dropleft
      data-test="articles-actions-dropdown-button"
      variant="plain"
      toggle-class="text-decoration-none"
      no-caret
      size="sm"
    >
      <template v-slot:button-content>
        <i class="fa-light fa-ellipsis-v" />
      </template>
      <b-dropdown-item
        @click="approveContentItem"
        v-if="GET_IS_SELF_SERVICE_CAMPAIGN_ACCESSED_BY_ADMIN"
        data-test="approve-content"
        :disabled="contentItem.state !== 'APPROVAL'"
      >
        Approve
      </b-dropdown-item>
      <b-dropdown-divider
        v-if="GET_IS_SELF_SERVICE_CAMPAIGN_ACCESSED_BY_ADMIN"
      />
      <b-dropdown-item
        @click="openArticleModal"
        data-test="delete-content"
        :disabled="isDeleteOptionDisabled"
      >
        <span id="delete-txt">Delete</span>
      </b-dropdown-item>
    </b-dropdown>
    <b-modal
      :id="`DeleteContentItem-${contentItem.id}`"
      title="Are you sure?"
      centered
      hide-header-close
      header-border-variant="p-1 border-bottom-1"
      footer-border-variant="p-1 border-top-1"
    >
      <p class="mb-0"> Are you sure you want to delete: <b>{{ contentItem.title }}</b> </p>

      <template #modal-footer>
        <button
          v-b-modal.modal-close_visit
          class="btn btn-sm mr-2 btn-tertiary"
          @click="closeModal"
        >
          Cancel
        </button>
        <button
          v-b-modal.modal-close_visit
          class="btn btn-danger btn-sm"
          @click="confirmDelete"
        >
          Delete
        </button>
      </template>
    </b-modal>
  </span>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import * as types from '@/modules/content/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'ContentItemActions',
  props: {
    contentItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState('content', [
      'feedId',
    ]),
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_CAMPAIGN_DRAFT,
      campaignTypes.GET_IS_CAMPAIGN_REVIEW,
      campaignTypes.GET_IS_SELF_SERVICE_CAMPAIGN_ACCESSED_BY_ADMIN,
    ]),
    isDeleteOptionDisabled() {
      return this.GET_IS_SELF_SERVICE_CAMPAIGN_ACCESSED_BY_ADMIN
        || !(this.GET_IS_CAMPAIGN_DRAFT || this.GET_IS_CAMPAIGN_REVIEW)
        || this.contentItem.state !== 'DRAFT';
    },
  },
  methods: {
    ...mapActions('content', [
      types.APPROVE_CONTENT_ITEM,
      types.DELETE_CONTENT_ITEM,
      types.FETCH_ARTICLES,
      types.FETCH_EXISTING_CONTENT_SCRAPES,
      types.SCRAPED_CONTENT,
    ]),
    approveContentItem() {
      this.APPROVE_CONTENT_ITEM(this.contentItem.id);
      this.FETCH_ARTICLES();
    },
    openArticleModal() {
      this.$root.$emit('bv::show::modal', `DeleteContentItem-${this.contentItem.id}`);
    },
    closeModal() {
      this.$root.$emit('bv::hide::modal', `DeleteContentItem-${this.contentItem.id}`);
    },
    confirmDelete() {
      this.deleteContentItem();
      this.closeModal();
    },
    async deleteContentItem() {
      const payload = {
        campaignId: this.campaign.id,
        feedId: this.feedId,
        id: this.contentItem.id,
        advertisersId: this.campaign.advertiserId,
      };
      await this.DELETE_CONTENT_ITEM(payload);
      this.FETCH_ARTICLES();
      this.SCRAPED_CONTENT(payload);
    },
  },
};
</script>
<style lang="scss">
#delete-txt {
  color: #D43421;
}
.disabled {
  #delete-txt {
    color: #F5D2D2;
  }
}
.dropdown-item:active {
  background-color: #F8F9Fa;
}
</style>
<style lang="scss" scoped>
::v-deep {
  .dropdown-menu {
    min-width: 40px !important;
  }
  .modal-footer {
    // border-top-color: #F6F6F6;
  }
  .modal-header {
    padding: 16px 30px;
    // border-bottom-color: #F6F6F6;
  }
  .modal-body {
    padding: 16px 30px;
  }
}
</style>
